import React from 'react';
import { useTranslation } from 'react-i18next';
import './navbar.scss';

const Navbar = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    // Get current path without language prefix
    const pathParts = window.location.pathname.split('/');
    const route = pathParts.length > 2 ? `/${pathParts.slice(2).join('/')}` : '';
    
    // Navigate to same page but with new language
    window.location.href = `/${lng}`;
    i18n.changeLanguage(lng);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        <a className="navbar-brand" href={`/${i18n.language}`}>
          <img src="/images/allenty-logo-removebg.png" alt="Logo" className="brand-logo" />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">

            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="servicesDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {t('navbar_services')}
              </a>
              <ul className="dropdown-menu" aria-labelledby="servicesDropdown">
                <li>
                  <a className="dropdown-item" href={`/${i18n.language}/${t('routes.inventory')}`}>{t('navbar_inventory')}</a>
                </li>
                <li className="nav-item">
                  <a className="dropdown-item" href={`/${i18n.language}/${t('routes.system')}`}>{t('navbar_system')}</a>
                </li>
                <li>
                  <a className="dropdown-item" href={`/${i18n.language}/impairment`}>Impairment</a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a className="nav-link" href={`/${i18n.language}/${t('routes.cases')}`}>{t('navbar_cases')}</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href={`#contact-form`}>{t('navbar_contact')}</a>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {t('language')}
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li>
                  <button className="dropdown-item" onClick={() => changeLanguage('pt-BR')}>{t('navbar_portuguese')}</button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={() => changeLanguage('en')}>{t('navbar_english')}</button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={() => changeLanguage('es')}>{t('navbar_spanish')}</button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;